<section id="viewerContainer" class="viewer-container">
  @if (shouldDisplayLoader$ | async) {
    <zbp-loading-placeholder></zbp-loading-placeholder>
  }

  @if (viewerAsset$ | async; as asset) {
    @if (asset.assetId) {
      <main id="viewer" class="viewer-component material-viewer-background">
        <div class="viewer-wrapper">
          <!-- Desktop: controls render before the header/asset so the controls are tabbed into first (controls sit on left side). -->
          @if (isDesktop) {
            <ng-container *ngTemplateOutlet="viewerControls"></ng-container>
          }
          <div class="asset-header-wrapper">
            <header id="viewerHeader" class="viewerHeader w-100 d-flex flex-nowrap m-0">
              <!-- Student doesn't need this as they already have a header. -->
              @if(!isInsideIframe) {
                <div class="mobile-logo-wrapper">
                  @if (!isZBPortal) {
                    <img class="appLogo"
                      src="assets/img/highlights.svg"
                      alt="highlights logo"
                      role="presentation"
                      />
                  } @else {
                    <img class="appLogo"
                      src="assets/img/zb-icon-white.svg"
                      alt="zb logo"
                      role="presentation"
                      />
                  }
                </div>
              }
              <h1 class="h6 viewer-header-title" data-cy="viewer-header-title" [innerHTML]="asset.category + ' - ' + asset.name"></h1>
              @if(hasTopicKey$ | async; as hasTopicKey) {
                @if(toggleAssets$ | async; as toggleAssets) {
                  @if(toggleAssets.length > 0) {
                    <div class="viewerHeaderToggleContainer" ngbDropdown [autoClose]="'inside'" #toggleDropdown="ngbDropdown">
                      @if (hasTopicKey) {
                        <button id="toggleDropdownButton" class="btn btn-sm" ngbDropdownToggle [innerHTML]="asset.name"></button>
                      }
                      <div aria-labelledby="toggleDropdownButton" ngbDropdownMenu>
                        @for (toggleAsset of toggleAssets; track toggleAsset.assetId; let i = $index) {
                          <button id="toggleAssetButton{{i}}" type="button" class="btn btn-sm assetToggleButton" ngbDropdownItem
                          (click)="handleToggledAsset(toggleAsset.assetId)" [innerHTML]="renderText(toggleAsset.name)"></button>
                        }
                      </div>
                    </div>
                  }
                }
              }
              <!-- On mobile, back button is in the header. CSS controls the show/hide.-->
              <zbp-viewer-back-button
                id="viewer-back-button-mobile"
                [isInsideIframe]="isInsideIframe"
                [isActivityComplete]="isActivityComplete">
              </zbp-viewer-back-button>
            </header>
            @if ({series: series$ | async, grade: grade$ | async}; as apipe) {
              <div class="viewerAssetWrapper">
                @if(messages$ | async; as messages) {
                  @if(messages.length) {
                    <aside  id="viewerAlert" role="alert" class="alert w-75 mx-auto my-1 text-center"
                      [class.alert-danger]="messages?.length">
                      @for (message of messages; track $index) {
                        <ul id="viewerAlertList">
                          <li>{{ message }}</li>
                        </ul>
                      }
                    </aside>
                  }
                }
                @switch (asset.viewerAssetType) {
                  @case ('Audio') {
                    <zbp-viewer-audio [asset]="asset" [series]="apipe.series" [grade]="apipe.grade" [viewerAssets]="assetList"
                    (loaded)="shouldDisplayLoader$.next(false)" (withError)="handleError($event)"></zbp-viewer-audio>
                  }
                  @case ('Canvas') {
                    <zbp-viewer-canvas [asset]="asset" [series]="apipe.series" [grade]="apipe.grade"
                      (loaded)="shouldDisplayLoader$.next(false)" (withError)="handleError($event)"
                      [zoomLevel]="zoomPercent"
                      [selectedTool]="activeTool"
                      [clearClicked]="clearClicked$"
                      [drawingColor]="drawingColor"
                      [brushSize]="brushSize"
                    ></zbp-viewer-canvas>
                  }
                  @case ('Image') {
                    <zbp-viewer-canvas
                      [asset]="asset"
                      [series]="apipe.series"
                      [grade]="apipe.grade"
                      (loaded)="shouldDisplayLoader$.next(false); onImageLoaded()"
                      (withError)="handleError($event)"
                      [zoomLevel]="zoomPercent"
                      [selectedTool]="activeTool"
                      [drawingColor]="drawingColor"
                      [brushSize]="brushSize"
                      [clearClicked]="clearClicked$"
                      />
                  }
                  @case ('Pdf') {
                    <zbp-viewer-document [asset]="asset" [series]="apipe.series" [grade]="apipe.grade"
                      (loaded)="shouldDisplayLoader$.next(false)" (withError)="handleError($event)"
                      [zoomLevel]="zoomPercent"
                    [locked]="false"></zbp-viewer-document>
                  }
                  @case ('PdfLocked') {
                    <zbp-viewer-document [asset]="asset" [series]="apipe.series"
                      [grade]="apipe.grade" (loaded)="shouldDisplayLoader$.next(false)"
                      (withError)="handleError($event)"
                      [zoomLevel]="zoomPercent"
                    [locked]="true"></zbp-viewer-document>
                  }
                  @case ('Ilb') {
                    <zbp-viewer-iframe [asset]="asset" [series]="apipe.series" [grade]="apipe.grade"
                    (loaded)="shouldDisplayLoader$.next(false)" (withError)="handleError($event)"></zbp-viewer-iframe>
                  }
                  @case ('Iwb') {
                    <zbp-viewer-iframe [asset]="asset" [series]="apipe.series" [grade]="apipe.grade"
                    (loaded)="shouldDisplayLoader$.next(false)" (withError)="handleError($event)"></zbp-viewer-iframe>
                  }
                  @case ('SuperSmart') {
                    <zbp-viewer-iframe
                      [asset]="asset"
                      [series]="apipe.series"
                      [grade]="apipe.grade"
                      (loaded)="shouldDisplayLoader$.next(false); onSuperSmartLoaded();"
                      (withError)="handleError($event)"
                      />
                  }
                  @case ('ImagePrint') {
                    <zbp-viewer-print-canvas [asset]="asset" [series]="apipe.series"
                      [grade]="apipe.grade"
                      (loaded)="shouldDisplayLoader$.next(false)"
                      (withError)="handleError($event)"
                      [zoomLevel]="zoomPercent"
                      [clearClicked]="clearClicked$"
                      [selectedTool]="activeTool"
                      [drawingColor]="drawingColor"
                      [brushSize]="brushSize"
                      [triggerPrint]="triggerPrint"
                      (isPrinting)="triggerPrint = $event.valueOf()"
                    ></zbp-viewer-print-canvas>
                  }
                  @case ('Video') {
                    <zbp-viewer-video
                      [asset]="asset"
                      (loaded)="shouldDisplayLoader$.next(false)"
                      (withError)="handleError($event)"
                      [zoomLevel]="zoomPercent"
                      (completed)="onVideoCompleted()"
                      />
                  }
                  @case ('VideoCanvas') {
                    <zbp-viewer-video-canvas [asset]="asset" [series]="apipe.series"
                      [grade]="apipe.grade"
                      [selectedTool]="activeTool"
                      [drawingColor]="drawingColor"
                      [brushSize]="brushSize"
                      [clearClicked]="clearClicked$"
                      (loaded)="shouldDisplayLoader$.next(false)"
                    (withError)="handleError($event)"></zbp-viewer-video-canvas>
                  }
                }
              </div>
            }
          </div>
          <!-- Mobile: controls render after the header/asset so the header is tabbed into first (controls sit at the bottom). -->
          @if (!isDesktop) {
            <ng-container *ngTemplateOutlet="viewerControls"></ng-container>
          }
          <!-- Template is for the controls. Rendered in different locations depending on screen size. -->
          <ng-template #viewerControls>
            @if ((viewerConfig$ | async) || isStudent) {
              <div class="viewer-controls">
                <zbp-viewer-controls
                  [viewerConfiguration]="viewerConfiguration"
                  [asset]="asset"
                  [viewerAssets]="assetList"
                  [isInsideIframe]="isInsideIframe"
                  [isActivityComplete]="isActivityComplete"
                  (activeTool)="setActiveTool($event)"
                  (zoomPercent)="setZoomPercent($event)"
                  (triggerPrint)="printImage()"
                  (clearDrawing)="clear()"
                  (activeColor)="setDrawingColor($event)"
                  (activeSize)="setBrushSize($event)"
                  [isDesktop]="isDesktop"
                  [isLessonNavigation]="isLessonNavigation"
                  [lessonSteps]="lessonSteps$ | async"
                  >
                </zbp-viewer-controls>
              </div>
            }
          </ng-template>
        </div>
      </main>
    }
  }

</section>
